const fortunesList = [
    "You will slip on a banana peel and horribly injure yourself. Be careful!",
    "Tomorrow will be a neutral day. Nothing good, nothing bad. Enjoy!",
    "You will be greeted by a mystical creature in your near future. Be on the lookout!",
    "A komodo dragon will come into your life and then leave without saying goodbye.",
    "Your next dream will reveal a lot about you...stay sharp!",
    "Next time you get in a car, look up. You'll see something you've never seen before.",
    "Buy two apples at the grocery store and just watch what happens next...that'll be a good story to tell!",
    "You have a great smile! That'll be important for what's coming tomorrow...",
    "Job interview, shmob interview. DON'T PREPARE, TAKE WHAT COMES AND RIDE THE WAVE.",
    "Tomorrow you will wake up next to a giant pile of cash. Congratulations!",
    "Yesterday is as good as it's gonna get. Prepare for a lifetime of disappointment.",
    "Your hair looks good! Don't change it. NEVER CHANGE YOUR HAIR. It will bring good fortune to you in the future.",
    "The next pair of shoes you buy will be your last.",
    "On this upcoming Wednesday, it is in your best interest to wear a monochrome baby blue ensemble.",
    "For your safety: avoid entering nightclubs, any Foot Locker location, and the closest Trader Joe's until further notice. Thank me later.",
    "You will learn the true value of friendship this upcoming Thursday.",
    "Wear your seatbelt! Wouldn't want to repeat what happened last week...",
    "Soon you will enter a higher state of consciousness and there's no going back...say your goodbyes now.",
    "You will soon feel an intense urge to do arts-and-crafts...",
    "You will soon find yourself upside down -- don't panic! Go with the flow.",
    "Bring tissues...your next pasta experience will be real, raw, and emotional."
];

export default fortunesList;